/**
 * Strip markdown formatting to produce clean plain text.
 *
 * Used for display contexts that need unformatted text:
 * - Search result snippets
 * - Note card previews
 * - AI title generation input
 */
export function stripMarkdown(md) {
    return (md
        // Remove code blocks BEFORE inline code (otherwise ``` gets mangled)
        .replace(/```\w*\n[\s\S]*?```/g, '')
        .replace(/^#{1,6}\s+/gm, '')
        .replace(/(\*{1,3}|_{1,3})(.*?)\1/g, '$2')
        .replace(/~~(.*?)~~/g, '$1')
        .replace(/`([^`]+)`/g, '$1')
        .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        // A block fence's own lines (`:::meetingSummary {…}`, its closing `:::`),
        // so a meeting note's preview starts with the card's words.
        .replace(/^[ \t]*:::.*$/gm, '')
        .replace(/^>\s?/gm, '')
        .replace(/^[-*_]{3,}\s*$/gm, '')
        .replace(/^[\s]*[-*+]\s+/gm, '')
        .replace(/^[\s]*\d+\.\s+/gm, '')
        .replace(/\|/g, ' ')
        .replace(/^[-:|\s]+$/gm, '')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/ {2,}/g, ' ')
        .trim());
}
/**
 * Strip markdown from a FRAGMENT: a search snippet cut out of a body
 * (`ts_headline`), which may open or close mid-syntax. `stripMarkdown` needs
 * paired markers and whole lines, so a cut left `**` and `](/collections/…)`
 * on screen. This one also drops unpaired markers and links cut at either
 * end, and returns one line.
 *
 * Highlight delimiters pass through untouched: the guillemets the entity
 * snippets use and the private-use pair the chat snippets use are not
 * markdown, and the renderer needs them.
 */
export function stripMarkdownFragment(fragment) {
    return (fragment
        .replace(/```\w*/g, ' ')
        .replace(/!?\[([^\]]*)\]\([^)]*(?:\)|$)/g, '$1')
        .replace(/\]\([^)\s]*\)?/g, '')
        .replace(/\[(?=[^\]]*$)/g, '')
        .replace(/(^|\n)[ \t]*(?:#{1,6}|>|[-*+]|\d+\.)[ \t]+/g, '$1')
        .replace(/^[-:|\s]+$/gm, '')
        // An asterisk between two word characters is arithmetic (1*10^6), not emphasis.
        .replace(/(?<![\p{L}\p{N}])\*+|\*+(?![\p{L}\p{N}])/gu, '')
        .replace(/~~|`/g, '')
        .replace(/(^|[\s(])_{1,2}(?=\S)|(?<=\S)_{1,2}(?=[\s).,;:!?]|$)/g, '$1')
        .replace(/\|/g, ' ')
        .replace(/\s+/g, ' ')
        .trim());
}
//# sourceMappingURL=strip-markdown.js.map